import React, { useState } from 'react';
import {
  Box,
  Stack,
  Cluster,
  CollapsibleSection,
  Motion,
  BoxWithShadow,
  Text,
  constants,
  Paragraph,
} from '@thecb/components';
import {
  formatPrice,
  titleCase,
  formatWithParentheses,
} from '../../utils/helpers';

export const OrderDetailsDebtItem = ({
  index,
  header,
  subheader,
  paid,
  isNegativeAmount,
  isRefund,
  fullAmount,
  externalAttributes,
  quantity,
  recordedPrice,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const amountPaid = paid || '0.00';
  const titleSection = (
    <Box>
      <Cluster justify="space-between" align="center">
        <Stack childGap=".25rem">
          <Text
            weight={constants.fontWeights.FONT_WEIGHT_BOLD}
            fontSize="1.125rem"
          >
            {header}
          </Text>
          <Text
            themeValues={{ fontSize: 'pL' }}
            color={constants.colors.CHARADE_GREY}
          >
            {subheader}
          </Text>
        </Stack>
        <Cluster>
          {quantity > 1 && (
            <Stack justify="center">
              <Text
                id={`quantity-at-recorded-price-${index}`}
                extraStyles={`text-align: right;`}
              >{`${formatPrice(recordedPrice)} per x ${quantity}`}</Text>
            </Stack>
          )}
          <Box padding="0" extraStyles={`min-width: 10rem;`}>
            <Stack childGap=".25rem">
              <Text
                extraStyles={`text-align: right; margin-left: 4rem;`}
                id={`debt-item-${index}-total`}
              >
                {isNegativeAmount
                  ? formatWithParentheses(formatPrice(amountPaid, isRefund))
                  : formatPrice(amountPaid, isRefund)}
              </Text>
              {fullAmount && (
                <Text
                  extraStyles={`text-align: right;`}
                  fontSize="1rem"
                  color={constants.colors.CHARADE_GREY}
                >
                  Full Amount: ${fullAmount}
                </Text>
              )}
            </Stack>
          </Box>
        </Cluster>
      </Cluster>
    </Box>
  );

  return (
    <Box padding="0 0 1rem" extraStyles={`:last-child { padding: 0px; }`}>
      <BoxWithShadow variant="baseStandard" padding="0">
        <Box padding="0">
          <CollapsibleSection
            supportsTouch={false}
            isOpen={isOpen}
            title={titleSection}
            initiallyOpen={false}
            toggleSection={() => setIsOpen(!isOpen)}
            customTitle={true}
          >
            <Motion
              variants={{
                open: { opacity: 1 },
                closed: { opacity: 0 },
              }}
              initial={'open'}
            >
              <Box padding="1rem" background="#eee" id="debt-item-attributes">
                {externalAttributes &&
                  Object.entries(externalAttributes).map(([key, value]) => (
                    <Box
                      key={`${key}-${value}`}
                      padding="0rem"
                      borderRadius=".25rem"
                    >
                      <Cluster extraStyles={`text-align:left`}>
                        <Box padding="0" extraStyles={`width:168px;`}>
                          <Paragraph
                            fontSize="1rem"
                            weight={constants.fontWeights.FONT_WEIGHT_SEMIBOLD}
                          >
                            {titleCase(key)}:
                          </Paragraph>
                        </Box>
                        <Box
                          padding="0"
                          extraStyles={`width: calc(100% - 168px);`}
                        >
                          <Paragraph fontSize="1rem">{value}</Paragraph>
                        </Box>
                      </Cluster>
                    </Box>
                  ))}
              </Box>
            </Motion>
          </CollapsibleSection>
        </Box>
      </BoxWithShadow>
    </Box>
  );
};
